$(function() {
    $('*[type=checkbox][name=shipping_not_the_same]').on('change', function(){
        if($(this).is(':checked')){
            Manogi.showShippingAddress();
        }
        else {
            Manogi.hideShippingAddress();
        }
    });
    
    $('*[data-action=save_address_and_continue]').on('click', function(){
        Manogi.saveAddressAndContinue($(this).closest('form'));
    });
});
